import { BotClickFilter } from "@redotech/redo-marketing-common/bot-click-filter";
import { outreachAnalyticsSchema } from "@redotech/redo-marketing-common/campaigns/campaign-definition";
import { outreachScopeValuesSchema } from "@redotech/redo-marketing-outreach-common/outreach";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getOutreachAnalytics = {
  name: "getOutreachAnalytics" as const,
  input: z.object({
    groupBy: outreachScopeValuesSchema,
    metricsStart: z
      .string()
      .optional()
      .describe("Start date for the analytics period (YYYY-MM-DD)"),
    metricsEnd: z
      .string()
      .optional()
      .describe("End date for the analytics period (YYYY-MM-DD)"),
    clickBotFilter: createEnum(BotClickFilter)
      .optional()
      .describe("Count only human or only bot clicks; omit for every click"),
  }),
  output: outreachAnalyticsSchema,
};
